import { render } from "./merpload.vue?vue&type=template&id=33a4c960"
import script from "./merpload.vue?vue&type=script&lang=js"
export * from "./merpload.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\work\\project\\intelegent\\ips\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__